import React, { useState } from 'react';
import { FormInput, InputGroup, InputGroupAddon, InputGroupText } from 'shards-react';
import { useTranslation } from 'react-i18next';
import type { AgGridReact } from 'ag-grid-react/lib/agGridReact';

interface TextFilteringProps {
  gridRef: React.MutableRefObject<AgGridReact>;
}

const TextFiltering = ({ gridRef }: TextFilteringProps): React.ReactElement => {
  const { t } = useTranslation();
  const gridApi = gridRef.current?.api ?? undefined;
  const [filteringText, setFilteringText] = useState<string>('');

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  /**
   * テキストフィルタリング
   */
  const handleChangeFilteringText = (event: React.ChangeEvent<{ value: string }>): void => {
    // console.log(event);
    const newValue: string = event.currentTarget.value;
    setFilteringText(newValue);
    if (gridApi) {
      gridApi.setQuickFilter(newValue);
    }
  };
  const handleResetFilterText = (): void => {
    // console.log(event);
    setFilteringText('');
    if (gridApi) {
      gridApi.setQuickFilter('');
    }
  };

  // VIEW
  // ================================================================================

  return (
    <>
      <InputGroup id="quickFiltering" seamless>
        <InputGroupAddon type="prepend">
          <InputGroupText>
            <i className="material-icons">search</i>
          </InputGroupText>
        </InputGroupAddon>
        <InputGroupAddon type="append" className="button-clear">
          <InputGroupText>
            <i className="material-icons" onClick={handleResetFilterText}>
              cancel
            </i>
          </InputGroupText>
        </InputGroupAddon>
        <FormInput id="quickFilter" onChange={handleChangeFilteringText} value={filteringText} placeholder={t('filter.default')} />
      </InputGroup>
    </>
  );
};

export default TextFiltering;
